<template>
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.99023 8.75977L8.91023 10.6798L10.8302 8.75977" stroke="#454558" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
    <path d="M8.91016 3V9.5" stroke="#454558" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
    <path d="M15 9.13477C15 12.4498 12.75 15.1348 9 15.1348C5.25 15.1348 3 12.4498 3 9.13477" stroke="#454558" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
  </svg>
</template>